export const PERFORMANCE_QUERY_KEYS = {
  dashboard: "performance.dashboard",
  goals: "performance.goals",
  goalDetail: "performance.goal.detail",
  feedback: "performance.feedback",
  competencyCategories: "performance.competency.categories",
  competencies: "performance.competencies",
  campaigns: "performance.360.campaigns",
  campaignDetail: "performance.360.campaign.detail",
  campaignReviews: "performance.360.reviews",
  reviews: "performance.reviews",
  reviewDetail: "performance.review.detail",
  reviewAnalytics: "performance.review.analytics",
  calibrations: "performance.calibrations",
  calibrationDetail: "performance.calibration.detail",
  analytics: "performance.analytics",
  goalCycles: "performance.masters.goalCycles",
  feedbackTypes: "performance.masters.feedbackTypes",
  reviewTemplates: "performance.masters.reviewTemplates",
};

export const GOAL_TYPES = ["OKR", "KRA", "KPI"];
export const GOAL_STATUSES = [
  "DRAFT",
  "PENDING_APPROVAL",
  "ACTIVE",
  "IN_PROGRESS",
  "COMPLETED",
  "CANCELLED",
  "REJECTED",
];
export const GOAL_PRIORITIES = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];
export const FEEDBACK_SENTIMENTS = ["POSITIVE", "NEUTRAL", "IMPROVEMENT"];
export const RELATION_TYPES = ["SELF", "MANAGER", "PEER", "SUBORDINATE"];
export const REVIEW_STATUSES = [
  "DRAFT",
  "SUBMITTED",
  "ACKNOWLEDGED",
  "FINALIZED",
];
export const MASTER_STATUSES = [
  "ACTIVE",
  "INACTIVE",
  "DRAFT",
  "LOCKED",
  "COMPLETED",
];
